// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8531) return "static/chunks/46dafc95-ed3f6ccdf8f9fcfe.js";
	if (chunkId === 4683) return "static/chunks/4683-fead22b9c8fe205b.js";
	if (chunkId === 7424) return "static/chunks/7424-abd43088ddd38f56.js";
	if (chunkId === 4888) return "static/chunks/4888-50eecd1902be20ce.js";
	if (chunkId === 2909) return "static/chunks/2909-14325883c19c0fd2.js";
	if (chunkId === 8069) return "static/chunks/8069-9da3ca33a863f49d.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9923 ? "8e095c31" : chunkId) + "." + {"2415":"23fb91fd6922059e","2442":"50cfd7ae2f1e95b1","5074":"2bc6701dd68d7980","5174":"d8a8152dfcfd64fa","5661":"1301cf2105618094","7879":"fc58a6536ab75175","8528":"f7c200029da07144","9379":"11423c5ff84c98f6","9715":"3df22be3de4d5ab0","9923":"512e0f83378eedca"}[chunkId] + ".js";
};